module.exports = __webpack_public_path__ + "img/ug352.59494db3.png";